<template>
  <DatePicker
    v-model="modelValue"
    :label="$tt('passport_expiry')"
    :max="getYearsAheadIso(20)"
    future
  />
</template>

<script setup lang="ts">
import { getYearsAheadIso } from '~/helpers/date';
import type { DateISO } from '~/types';

const modelValue = defineModel<DateISO>({ required: true });
</script>